// import React from "react";
// import { Link } from "react-router-dom";

// export default function WhyChooseHLC() {
//   return (
//     <>
//  <style>{`
//   :root {
//     --hlc-magenta: #9b1f6c;
//     --hlc-plum: #542757;
//     --hlc-navy: #35335b;
//     --hlc-mid: #4a3561;
//   }

//   /* SECTION */
//   #hlc-why8v2 {
//     padding: 52px 0;
//     color: #fff;
//     background: linear-gradient(
//       180deg,
//       #542757 0%,
//       #4a3561 40%,
//       #35335b 100%
//     );
//     font-family: "Open Sans", sans-serif;
//   }

//   .why8v2__wrap {
//     width: min(1320px, 94%);
//     margin: auto;
//     text-align: center;
//   }

//   /* HEADER */
//   .why8v2__eyebrow {
//     letter-spacing: 0.18em;
//     font-size: 12px;
//     opacity: 0.7;
//     margin-bottom: 6px;
//     text-transform: uppercase;
//   }

//   .why8v2__title {
//     font-size: 40px;
//     font-weight: 800;
//     margin: 0 0 8px;
//     line-height: 1.15;
//   }

//   .why8v2__accent {
//     color: var(--hlc-magenta);
//   }

//   .why8v2__sub {
//     opacity: 0.85;
//     margin: auto;
//     font-size: 15px;
//     line-height: 1.5;
//     white-space: nowrap;
//     max-width: 100%;
//   }

//   /* GRID */
//   .why8v2__grid {
//     display: grid;
//     grid-template-columns: repeat(3, 1fr);
//     gap: 18px;
//     margin-top: 32px;
//     align-items: stretch;
//   }

//   /* CARD */
//   .why8v2__card {
//     background: rgba(255, 255, 255, 0.06);
//     border: 1px solid rgba(255, 255, 255, 0.15);
//     padding: 18px 20px;
//     text-align: left;
//     position: relative;
//     transition: transform 0.3s ease, box-shadow 0.3s ease,
//       background 0.3s ease;
//     min-height: 138px;
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//   }

//   .why8v2__card:hover {
//     transform: translateY(-6px);
//     box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
//     background: rgba(255, 255, 255, 0.09);
//   }

//   .why8v2__card::before {
//     content: "";
//     position: absolute;
//     left: 0;
//     top: 0;
//     bottom: 0;
//     width: 3px;
//     background: var(--hlc-magenta);
//   }

//   .why8v2__card-title {
//     margin: 0 0 6px;
//     font-weight: 700;
//     font-size: 19px;
//     line-height: 1.25;
//   }

//   .why8v2__card-text {
//     opacity: 0.85;
//     font-size: 14px;
//     line-height: 1.55;
//     margin: 0;
//   }

//   /* CTA */
//   .why8v2__cta {
//     margin-top: 22px;
//     display: flex;
//     justify-content: center;
//     gap: 14px;
//     flex-wrap: wrap;
//   }

//   .btn {
//     padding: 11px 22px;
//     text-decoration: none;
//     font-weight: 700;
//     transition: all 0.3s ease;
//     display: inline-flex;
//     align-items: center;
//     justify-content: center;
//     min-width: 165px;
//     border-radius: 0;
//   }

//   .btn--primary {
//     background: var(--hlc-magenta);
//     color: #fff;
//     border: 1px solid var(--hlc-magenta);
//   }

//   .btn--ghost {
//     border: 1px solid rgba(255, 255, 255, 0.4);
//     color: #fff;
//     background: transparent;
//   }

//   /* ================= TABLET ================= */
//   @media (max-width: 991px) {
//     .why8v2__grid {
//       grid-template-columns: 1fr;
//       gap: 16px;
//     }

//     .why8v2__title {
//       font-size: 34px;
//     }

//     .why8v2__sub {
//       white-space: normal;
//       font-size: 15px;
//     }
//   }

//   /* ================= MOBILE OPTIMIZED ================= */
//   @media (max-width: 600px) {

//     #hlc-why8v2 {
//       padding: 28px 0; /* 🔥 reduced height */
//     }

//     .why8v2__wrap {
//       width: 92%;
//     }

//     .why8v2__title {
//       font-size: 26px;
//       margin-bottom: 6px;
//     }

//     .why8v2__sub {
//       font-size: 13px;
//       line-height: 1.5;
//       white-space: normal;
//       margin-bottom: 6px;
//     }

//     .why8v2__grid {
//       margin-top: 18px; /* 🔥 tighter spacing */
//       gap: 10px;
//     }

//     .why8v2__card {
//       padding: 14px 14px;
//       min-height: auto; /* 🔥 removes tall cards */
//     }

//     .why8v2__card-title {
//       font-size: 16px;
//     }

//     .why8v2__card-text {
//       font-size: 13px;
//       line-height: 1.4;
//     }

//     .why8v2__cta {
//       margin-top: 16px;
//       gap: 10px;
//     }

//     .btn {
//       width: 100%;
//       max-width: 260px;
//       min-width: unset;
//       padding: 10px 14px;
//       font-size: 13px;
//     }
//       @media (max-width: 600px) {

//   .why8v2__cta {
//     margin-top: 16px;
//     gap: 10px;
//     flex-wrap: nowrap;          /* 🔥 keep in one row */
//     justify-content: center;
//   }

//   .btn {
//     width: auto;                /* remove full width */
//     min-width: unset;
//     max-width: 160px;           /* 🔥 smaller buttons */
//     padding: 9px 14px;          /* smaller size */
//     font-size: 12.5px;          /* smaller text */
//     flex: 1;                    /* allow equal sizing */
//   }

//   .why8v2__wrap {
//     width: 92%;                /* keeps spacing from edges */
//   }
// }
//   }
// `}</style>

//       <section id="hlc-why8v2" aria-label="Why Choose HLC Lighting">
//         <div className="why8v2__wrap">
//           <header className="why8v2__head">
//             <div className="why8v2__eyebrow">WHY CHOOSE</div>
//             <h2 className="why8v2__title">
//               HLC Lighting<span className="why8v2__accent">.</span>
//             </h2>
//             <p className="why8v2__sub">
//               Built for Pakistan. Energy-efficient LEDs, rock-solid warranty, and nationwide delivery you can count on.
//             </p>
//           </header>

//           <div className="why8v2__grid">
//             <article className="why8v2__card">
//               <h3 className="why8v2__card-title">1-Year Warranty</h3>
//               <p className="why8v2__card-text">
//                 Peace of mind on every purchase with quick replacement support.
//               </p>
//             </article>

//             <article className="why8v2__card">
//               <h3 className="why8v2__card-title">Energy Efficient</h3>
//               <p className="why8v2__card-text">
//                 Save up to 85% electricity with high-efficacy LED drivers.
//               </p>
//             </article>

//             <article className="why8v2__card">
//               <h3 className="why8v2__card-title">Nationwide Delivery</h3>
//               <p className="why8v2__card-text">
//                 TCS / Leopards / M&amp;P — usually 2–4 business days.
//               </p>
//             </article>
//           </div>

//           {/* <div className="why8v2__ribbon">
//             <div className="stat">
//               <span className="num">25,000+</span>
//               <span className="lab">Orders Delivered</span>
//             </div>

//             <div className="sep"></div>

//             <div className="stat">
//               <span className="num">200+</span>
//               <span className="lab">Retail Partners</span>
//             </div>

//             <div className="sep"></div>

//             <div className="stat">
//               <span className="num">ISO / CE</span>
//               <span className="lab">Compliance</span>
//             </div>
//           </div> */}

//           <div className="why8v2__cta">
//             <Link to="/shop" className="btn btn--primary">
//               Shop Now
//             </Link>

//             <Link to="/dealer" className="btn btn--ghost">
//               Become a Dealer
//             </Link>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }


import React, { useLayoutEffect, useRef } from "react";
import { Link } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const REASONS = [
  {
    n: "01",
    key: "warranty",
    title: "1-Year Warranty",
    text: "Peace of mind on every purchase with quick replacement support.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2l8 3v6c0 5-3.4 9-8 11-4.6-2-8-6-8-11V5z" />
        <path d="M9 12l2 2 4-4" />
      </svg>
    ),
  },
  {
    n: "02",
    key: "efficient",
    title: "Energy Efficient",
    text: "Save up to 85% electricity with high-efficacy LED drivers.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M11 3C7 5 5 8 5 12a7 7 0 0 0 14 0c0-1.5-.5-3-1.5-4.5C16 9 14 9 13 7c-.8-1.5-1-2.7-2-4z" />
      </svg>
    ),
  },
  {
    n: "03",
    key: "delivery",
    title: "Nationwide Delivery",
    text: "TCS / Leopards / M&P — usually 2–4 business days.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 7h11v8H2z" /><path d="M13 10h4l3 3v2h-7z" />
        <circle cx="6" cy="18" r="1.7" /><circle cx="17" cy="18" r="1.7" />
      </svg>
    ),
  },
];

export default function WhyChoose() {
  const root = useRef(null);

  useLayoutEffect(() => {
    const REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const isTouch = window.matchMedia("(hover: none)").matches;
    if (REDUCED) return;

    const ctx = gsap.context(() => {
      gsap.from(".wc-head > *", {
        y: 24, opacity: 0, duration: 0.7, stagger: 0.09, ease: "power3.out",
        scrollTrigger: { trigger: root.current, start: "top 80%" },
      });
      gsap.fromTo(".wc-card",
        { y: 50, opacity: 0, scale: 0.94 },
        {
          y: 0, opacity: 1, scale: 1, duration: 0.85, stagger: 0.14, ease: "power3.out",
          scrollTrigger: { trigger: ".wc-deck", start: "top 84%", once: true },
        }
      );
      gsap.from(".wc-actions", {
        y: 18, opacity: 0, duration: 0.6, ease: "power3.out",
        scrollTrigger: { trigger: ".wc-actions", start: "top 94%", once: true },
      });
    }, root);

    /* cursor light pool inside each card */
    let handlers = [];
    if (!isTouch) {
      root.current.querySelectorAll(".wc-card").forEach((card) => {
        const move = (e) => {
          const b = card.getBoundingClientRect();
          card.style.setProperty("--mx", `${((e.clientX - b.left) / b.width) * 100}%`);
          card.style.setProperty("--my", `${((e.clientY - b.top) / b.height) * 100}%`);
        };
        card.addEventListener("pointermove", move);
        handlers.push([card, move]);
      });
    }

    return () => {
      ctx.revert();
      handlers.forEach(([c, m]) => c.removeEventListener("pointermove", m));
    };
  }, []);

  return (
    <section id="why-choose" aria-label="Why choose HLC Lighting" ref={root}>
      <style>{`
/* ============================================================
   HLC — Why Choose · Fanned 3D Perspective Deck
   All selectors scoped under #why-choose. No generic globals,
   so nothing collides with Hero / SmartTechnology / others.
   ============================================================ */
#why-choose{
  --wc-magenta:#e0249b;
  --wc-magenta-deep:#9b1f6c;
  --wc-plum:#542757;
  --wc-void:#080310;
  --wc-glass:rgba(22,10,30,.62);
  --wc-ease:cubic-bezier(.16,1,.3,1);
  position:relative;
  width:100%;
  padding:clamp(52px,6.5vw,96px) clamp(18px,5vw,64px) clamp(56px,7vw,104px);
  background:
    radial-gradient(60% 50% at 50% 78%, rgba(155,31,108,.16), transparent 60%),
    radial-gradient(120% 80% at 12% 6%, rgba(84,39,87,.24), transparent 58%),
    var(--wc-void);
  color:#fff;
  overflow:hidden;
  isolation:isolate;
  font-family:"Manrope","Inter",system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
  box-sizing:border-box;
}
#why-choose *,#why-choose *::before,#why-choose *::after{ box-sizing:border-box; }

/* faint ambient + flowing light streaks like the reference */
#why-choose .wc-ambient{
  position:absolute; inset:0; z-index:0; pointer-events:none;
  background:radial-gradient(44% 36% at 50% 82%, rgba(224,36,155,.18), transparent 62%);
}
#why-choose .wc-streaks{ position:absolute; inset:0; z-index:0; pointer-events:none; overflow:hidden; }
#why-choose .wc-streaks i{
  position:absolute; left:-10%; right:-10%; height:1px;
  background:linear-gradient(90deg, transparent, rgba(224,36,155,.45), transparent);
  filter:blur(.5px);
}
#why-choose .wc-streaks i:nth-child(1){ top:52%; transform:rotate(-4deg); opacity:.5; }
#why-choose .wc-streaks i:nth-child(2){ top:62%; transform:rotate(-7deg); opacity:.3; }

#why-choose .wc-wrap{
  position:relative; z-index:2;
  width:min(1180px,100%); margin:0 auto;
}

/* ---------- heading (centered, like the reference) ---------- */
#why-choose .wc-head{ text-align:center; max-width:720px; margin:0 auto clamp(30px,4vw,52px); }
#why-choose .wc-eyebrow{
  margin:0 0 12px; font-size:clamp(10px,1.4vw,12px); font-weight:800;
  letter-spacing:.34em; text-transform:uppercase; color:var(--wc-magenta);
}
#why-choose .wc-title{
  margin:0 0 14px;
  font-family:"Sora","Manrope",sans-serif;
  font-size:clamp(30px,5.4vw,58px); font-weight:800; line-height:1.04;
  letter-spacing:-.02em; color:#fff;
}
#why-choose .wc-accent{ color:var(--wc-magenta); }
#why-choose .wc-sub{
  margin:0 auto; max-width:560px;
  font-size:clamp(14px,1.5vw,16px); line-height:1.65; color:rgba(255,255,255,.7);
}

/* ---------- fanned 3D deck ---------- */
#why-choose .wc-deck{
  position:relative;
  display:flex; justify-content:center; align-items:center;
  gap:clamp(14px,1.4vw,22px);
  perspective:1600px;
  padding:clamp(10px,2vw,26px) 0 clamp(30px,4vw,60px);
}

/* ---------- card ---------- */
#why-choose .wc-card{
  --mx:50%; --my:110%;
  position:relative; isolation:isolate;
  opacity:1; /* visible even if JS fails */
  flex:1 1 0; min-width:0; max-width:clamp(280px,30vw,360px);
  display:flex; flex-direction:column;
  padding:clamp(22px,2.2vw,30px);
  border-radius:18px;
  background:
    linear-gradient(180deg, rgba(255,255,255,.05), rgba(255,255,255,.012)),
    var(--wc-glass);
  border:1px solid rgba(224,36,155,.5);
  -webkit-backdrop-filter:blur(10px); backdrop-filter:blur(10px);
  box-shadow:
    0 0 0 1px rgba(224,36,155,.14),
    0 18px 50px rgba(0,0,0,.5),
    0 0 34px rgba(224,36,155,.14);
  transform-style:preserve-3d;
  transition:transform .55s var(--wc-ease), box-shadow .55s var(--wc-ease),
             border-color .55s var(--wc-ease), opacity .55s var(--wc-ease), filter .55s var(--wc-ease);
  will-change:transform;
}
/* the fan: 01 tilts right, 03 tilts left, 02 faces front & dominant */
#why-choose .wc-card--warranty{ transform:rotateY(16deg) translateZ(-40px); }
#why-choose .wc-card--delivery{ transform:rotateY(-16deg) translateZ(-40px); }
#why-choose .wc-card--efficient{
  transform:translateZ(30px) scale(1.06);
  z-index:3;
  border-color:rgba(224,36,155,.75);
  box-shadow:
    0 0 0 1px rgba(224,36,155,.24),
    0 26px 60px rgba(0,0,0,.55),
    0 30px 70px rgba(224,36,155,.32);
}
/* intense glow pooling under the dominant centre card */
#why-choose .wc-card--efficient::before{
  content:""; position:absolute; left:50%; bottom:-26px; transform:translateX(-50%);
  width:70%; height:60px; border-radius:50%;
  background:radial-gradient(closest-side, rgba(224,36,155,.6), transparent);
  filter:blur(10px); z-index:-1; pointer-events:none;
}

/* cursor light pool */
#why-choose .wc-card__glow{
  position:absolute; inset:0; z-index:0; border-radius:18px; pointer-events:none;
  opacity:0; transition:opacity .45s var(--wc-ease);
  background:radial-gradient(240px 240px at var(--mx) var(--my), rgba(224,36,155,.2), transparent 60%);
}

/* ---------- card top: number + circular badge ---------- */
#why-choose .wc-card__top{
  position:relative; z-index:2;
  display:flex; align-items:flex-start; justify-content:space-between;
  margin-bottom:clamp(20px,2.6vw,32px);
}
#why-choose .wc-num__fig{
  display:block;
  font-family:"Sora","Manrope",sans-serif; font-weight:800;
  font-size:clamp(38px,4.6vw,60px); line-height:1; letter-spacing:-.03em;
  color:var(--wc-magenta);
}
#why-choose .wc-num__rule{
  display:block; width:34px; height:3px; margin-top:10px; border-radius:2px;
  background:var(--wc-magenta);
}
#why-choose .wc-badge{
  display:grid; place-items:center;
  width:clamp(46px,4.6vw,58px); height:clamp(46px,4.6vw,58px);
  border-radius:50%; color:var(--wc-magenta);
  background:radial-gradient(circle at 50% 40%, rgba(224,36,155,.18), rgba(224,36,155,.04));
  border:1px solid rgba(224,36,155,.5);
  box-shadow:0 0 18px rgba(224,36,155,.24), inset 0 0 12px rgba(224,36,155,.1);
  transition:transform .5s var(--wc-ease), box-shadow .5s var(--wc-ease), background .5s var(--wc-ease), color .5s var(--wc-ease);
}
#why-choose .wc-badge svg{ width:46%; height:46%; }

#why-choose .wc-card__title{
  position:relative; z-index:2;
  margin:0 0 12px; font-size:clamp(19px,2.1vw,24px); font-weight:800;
  letter-spacing:-.01em; color:#fff;
}
#why-choose .wc-card__underline{
  display:block; width:44px; height:2px; margin-bottom:clamp(14px,1.8vw,20px);
  background:var(--wc-magenta); border-radius:2px; opacity:.85;
}
#why-choose .wc-card__text{
  position:relative; z-index:2;
  margin:0 0 clamp(20px,2.6vw,30px);
  font-size:clamp(13.5px,1.5vw,15.5px); line-height:1.6; color:rgba(255,255,255,.72);
}

/* circular arrow button */
#why-choose .wc-card__arrow{
  position:relative; z-index:2; margin-top:auto;
  display:grid; place-items:center; width:40px; height:40px; border-radius:50%;
  color:var(--wc-magenta);
  background:rgba(224,36,155,.08);
  border:1px solid rgba(224,36,155,.5);
  transition:transform .4s var(--wc-ease), background .4s var(--wc-ease), color .4s var(--wc-ease), box-shadow .4s var(--wc-ease);
}
#why-choose .wc-card__arrow svg{ width:18px; height:18px; }

/* ---------- hover / activation ---------- */
@media (hover:hover){
  #why-choose .wc-card--warranty:hover{ transform:rotateY(10deg) translateZ(10px) translateY(-6px); }
  #why-choose .wc-card--delivery:hover{ transform:rotateY(-10deg) translateZ(10px) translateY(-6px); }
  #why-choose .wc-card--efficient:hover{ transform:translateZ(46px) scale(1.08) translateY(-6px); }
  #why-choose .wc-card:hover{
    border-color:rgba(224,36,155,.95);
    box-shadow:
      0 0 0 1px rgba(224,36,155,.4),
      0 30px 66px rgba(0,0,0,.55),
      0 0 48px rgba(224,36,155,.4);
  }
  #why-choose .wc-card:hover .wc-card__glow{ opacity:1; }
  #why-choose .wc-card:hover .wc-badge{
    background:linear-gradient(160deg, var(--wc-magenta), var(--wc-magenta-deep));
    color:#fff; box-shadow:0 0 26px rgba(224,36,155,.5);
  }
  #why-choose .wc-card:hover .wc-card__arrow{
    background:var(--wc-magenta); color:#fff;
    box-shadow:0 8px 22px rgba(224,36,155,.5); transform:translateX(3px);
  }
  #why-choose .wc-deck:hover .wc-card:not(:hover){ opacity:.72; filter:saturate(.85); }
}

/* ---------- CTA row ---------- */
#why-choose .wc-actions{
  display:flex; justify-content:center; gap:clamp(14px,1.6vw,20px); flex-wrap:wrap;
  margin-top:clamp(20px,2.6vw,34px);
}
#why-choose .wc-btn{
  position:relative; overflow:hidden;
  display:inline-flex; align-items:center; justify-content:center; gap:12px;
  padding:15px clamp(28px,3vw,44px); border-radius:12px;
  font-size:clamp(13px,1.5vw,15px); font-weight:700; letter-spacing:.02em;
  text-decoration:none; white-space:nowrap; cursor:pointer; min-width:clamp(200px,22vw,260px);
  transition:transform .4s var(--wc-ease), box-shadow .4s var(--wc-ease),
             background .4s var(--wc-ease), color .4s var(--wc-ease), border-color .4s var(--wc-ease);
}
#why-choose .wc-btn svg{ width:18px; height:18px; }
#why-choose .wc-btn--solid{
  color:#fff; border:1px solid transparent;
  background:linear-gradient(120deg, var(--wc-magenta-deep), var(--wc-magenta));
  box-shadow:0 14px 36px rgba(224,36,155,.4);
}
#why-choose .wc-btn--solid:hover{ transform:translateY(-3px); box-shadow:0 20px 48px rgba(224,36,155,.55); }
#why-choose .wc-btn--ghost{
  color:#fff; background:rgba(224,36,155,.05); border:1px solid rgba(224,36,155,.6);
}
#why-choose .wc-btn--ghost:hover{ transform:translateY(-3px); background:rgba(224,36,155,.14); border-color:var(--wc-magenta); }

/* ============================================================
   RESPONSIVE — fluid via clamp(); structural breaks only where
   the 3D fan would break down.
   ============================================================ */

/* below ~1024 the fan gets cramped — flatten the rotation, keep 3 across */
@media (max-width:1024px){
  #why-choose .wc-card--warranty{ transform:rotateY(8deg) translateZ(-16px); }
  #why-choose .wc-card--delivery{ transform:rotateY(-8deg) translateZ(-16px); }
  #why-choose .wc-card--efficient{ transform:translateZ(14px) scale(1.03); }
  #why-choose .wc-card{ max-width:none; }
}

/* tablet portrait / large phone: drop the 3D fan, stack vertically
   (a fanned perspective doesn't read on narrow screens) */
@media (max-width:820px){
  #why-choose .wc-deck{
    flex-direction:column; perspective:none; gap:clamp(16px,3.5vw,22px);
    padding-bottom:clamp(24px,4vw,40px);
  }
  #why-choose .wc-card,
  #why-choose .wc-card--warranty,
  #why-choose .wc-card--delivery,
  #why-choose .wc-card--efficient{
    transform:none !important; scale:1 !important;
    width:100%; max-width:520px; margin:0 auto;
  }
  #why-choose .wc-card--efficient::before{ display:none; }
  @media (hover:hover){
    #why-choose .wc-card:hover,
    #why-choose .wc-card--warranty:hover,
    #why-choose .wc-card--delivery:hover,
    #why-choose .wc-card--efficient:hover{ transform:translateY(-6px) !important; }
  }
}

@media (max-width:460px){
  #why-choose .wc-actions{ flex-direction:column; align-items:stretch; }
  #why-choose .wc-btn{ width:100%; min-width:0; }
}

@media (prefers-reduced-motion:reduce){
  #why-choose .wc-card{ transition:opacity .3s ease, border-color .3s ease; }
  #why-choose .wc-btn::before{ display:none; }
}

      `}</style>

      <div className="wc-ambient" aria-hidden="true" />
      <div className="wc-streaks" aria-hidden="true"><i /><i /></div>

      <div className="wc-wrap">
        <div className="wc-head">
          <p className="wc-eyebrow">Why Choose</p>
          <h2 className="wc-title">HLC Lighting<span className="wc-accent">.</span></h2>
          <p className="wc-sub">
            Built for Pakistan. Energy-efficient LEDs, rock-solid warranty, and
            nationwide delivery you can count on.
          </p>
        </div>

        <div className="wc-deck">
          {REASONS.map((r) => (
            <article className={`wc-card wc-card--${r.key}`} key={r.n}>
              <span className="wc-card__glow" aria-hidden="true" />
              <div className="wc-card__top">
                <div className="wc-num">
                  <span className="wc-num__fig">{r.n}</span>
                  <span className="wc-num__rule" aria-hidden="true" />
                </div>
                <span className="wc-badge" aria-hidden="true">{r.icon}</span>
              </div>
              <h3 className="wc-card__title">{r.title}</h3>
              <span className="wc-card__underline" aria-hidden="true" />
              <p className="wc-card__text">{r.text}</p>
              <span className="wc-card__arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 6l6 6-6 6" /></svg>
              </span>
            </article>
          ))}
        </div>

        <div className="wc-actions">
          <Link className="wc-btn wc-btn--solid" to="/shop">
            Shop Now <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
          </Link>
          <Link className="wc-btn wc-btn--ghost" to="/become-a-dealer">
            Become a Dealer <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
